import type { ProviderFile } from "fileParsing/types";
import { parseFn } from "./parse";
import { createSchema } from "./schema";
import { AlgoStep } from "./types";

export const extractSchemaFn = (file: ProviderFile, files: ProviderFile[]): ProviderFile => {
  // parses raw data into json data
  const { structure } = parseFn(file);
  // creates
  const schema = createSchema(undefined, structure, files);

  return {
    ...file,
    parserData: {
      ...file.parserData,
      schema,
      structure,
      algoStep: AlgoStep.Transform,
    },
  };
};
